/**
 * @desc 导入采购调价申请单模板下载
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/importProcurementTemplate`, {
      method: "GET",

      ...options,
    }),
  );
}
